import Footer from "../../component/Footer";
import Navbar from "../../component/Navbar";
import React, { useState, useEffect } from "react";
import $ from "jquery"; // Import jQuery
import "jquery-ui-dist/jquery-ui.css"; // Import jQuery UI CSS
import "jquery-ui-dist/jquery-ui.js"; // Import jQuery UI JS
import { useNavigate } from "react-router-dom";

function BusBookingSearch() {
  const [departureDate, setDepartureDate] = useState("");
  const navigate = useNavigate();

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    
    const formData = {
      from: e.target.from.value,
      to: e.target.to.value,
      departure: departureDate,
    };

    console.log("formData", formData);
    
    // Convert formData to query parameters
    const queryParams = new URLSearchParams(formData).toString();
    navigate(`/bus-search-result?${queryParams}`);
  };

  useEffect(() => {
    const today = new Date();
    $("#departure-datepicker").datepicker({
      dateFormat: "dd M y",
      minDate: today,
      defaultDate: today,
      onSelect: function (dateText, inst) {
        setDepartureDate(
          `${inst.selectedYear}-${(inst.selectedMonth + 1)
            .toString()
            .padStart(2, "0")}-${inst.selectedDay.toString().padStart(2, "0")}`
        );
      },
    });

    $("#departure-datepicker").datepicker("setDate", today);
  }, []);

  return (
    <>
      <Navbar />
      <div className="bgsearch1">
        <div className="container bg-2 midle">
          <h1 className="text-start agenth1 font3 txt6">Search Bus</h1>
          <hr />

          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="row g-3 text-start mb-3">
              <div className="col-md-4 mx-0 px-0">
                <label className="text-dark mb-2 labelset1 font3">From</label>
                <input
                  type="text"
                  className="input2"
                  name="from"
                  placeholder="Enter departure city"
                  required
                />
              </div>

              <div className="col-md-4 mx-0 px-0">
                <label className="text-dark mb-2 labelset1 font3">To</label>
                <input
                  type="text"
                  className="input2"
                  name="to"
                  placeholder="Enter destination city"
                  required
                />
              </div>

              <div className="col-md-4 mx-0 px-0">
                <label className="text-dark mb-2 labelset1 font3">Departure Date</label>
                <input
                  type="text"
                  id="departure-datepicker"
                  className="input2"
                  name="departure"
                  placeholder="Select date"
                  required
                />
              </div>
            </div>

            <div>
              <button type="submit" className="submit-btn mt-3">Search</button>
            </div>
          </form>

          <hr className="mt-4" />
          <p>
            The Bus Booking page allows users to search and book bus tickets
            easily. Enter your departure and destination cities, select a date,
            and find available buses quickly.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default BusBookingSearch;
